module.exports = __webpack_public_path__ + "img/plus.f14c7034.jpg";